import { useCallback } from 'react'
import { useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { AppButton, AppDivider, AppParagraph } from 'client/ui-building-blocks'
import { useAppContext, usePage, usePageStateContext } from 'client/hooks'
import { FormName } from 'client/utils'

const AuthInfo = () => {
  const { t } = useTranslation()
  const { pathname } = useLocation()

  const { authUser } = useAppContext()
  const { authForm, setAuthForm } = usePageStateContext()
  const { navigateTo } = usePage()

  const onRegisterBtnClick = useCallback(() => {
    setAuthForm(FormName.RegistrationForm)
    navigateTo({ path: '/auth' })
  }, [setAuthForm, navigateTo])

  return (
    <div style={{ height: '100px', border: '1px solid transparent' }}>
      {!authUser && (pathname !== '/auth' || authForm !== FormName.RegistrationForm) ? (
        <>
          <AppDivider size="xxsmall" />
          <AppButton
            variant="outlined"
            text={t('rootPage.topBar.dontHaveAnAccount')}
            position="center"
            onClick={onRegisterBtnClick}
          />
          <AppDivider size="medium" />
        </>
      ) : null}
      {authUser ? (
        <>
          <AppDivider size="xxsmall" />
          <AppParagraph
            text={t('rootPage.topBar.loggedInAs') + ' ' + authUser.username}
            centered
            size="small"
            marginBottom="medium"
          />
        </>
      ) : null}
    </div>
  )
}

export default AuthInfo
